import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";

const ORDER = ["basic", "standard", "premium"];

export const TierCards = ({ tiers, onSelect }) => {
  if (!tiers) return null;
  return (
    <div data-testid="tier-cards" className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-4 lg:gap-6 items-stretch">
      {ORDER.map((key) => {
        const tier = tiers[key];
        if (!tier) return null;
        const isRec = !!tier.recommended;
        return (
          <div
            key={key}
            data-testid={`tier-card-${key}`}
            className={`relative flex flex-col border transition-transform duration-300 hover:-translate-y-1 ${
              isRec
                ? "bg-ink text-cream border-ink md:scale-105 shadow-brutal-flame z-10"
                : "bg-white text-ink border-black/10 hover:shadow-brutal"
            }`}
          >
            {isRec && (
              <span
                data-testid="tier-recommended-badge"
                className="absolute -top-3 left-1/2 -translate-x-1/2 bg-flame text-white text-[10px] font-bold tracking-[0.2em] uppercase px-4 py-1.5"
              >
                Recommended
              </span>
            )}
            <div className="p-8 flex-1 flex flex-col">
              <p className={`text-xs font-bold tracking-[0.2em] uppercase ${isRec ? "text-flame" : "text-ink/50"}`}>
                {tier.tagline}
              </p>
              <h3 className="font-display text-3xl uppercase mt-2">{tier.name}</h3>
              <div className="mt-6 flex items-end gap-2">
                <span className="font-display text-5xl leading-none" data-testid={`tier-price-${key}`}>
                  ${tier.price?.toLocaleString()}
                </span>
                <span className={`text-xs font-semibold mb-1 ${isRec ? "text-cream/60" : "text-ink/50"}`}>/ person</span>
              </div>
              <ul className="mt-8 space-y-3 flex-1">
                {(tier.includes || []).map((item, i) => (
                  <li key={i} className="flex items-start gap-3 text-sm">
                    <Check className={`w-4 h-4 mt-0.5 shrink-0 ${isRec ? "text-flame" : "text-ink/40"}`} />
                    <span className={isRec ? "text-cream/85" : "text-ink/75"}>{item}</span>
                  </li>
                ))}
              </ul>
              <Button
                onClick={() => onSelect && onSelect(key)}
                data-testid={`tier-select-${key}`}
                className={`mt-8 w-full rounded-none font-bold uppercase tracking-widest text-xs h-12 transition-transform hover:-translate-y-0.5 ${
                  isRec
                    ? "bg-flame hover:bg-flame/90 text-white"
                    : "bg-ink hover:bg-ink/90 text-cream"
                }`}
              >
                Pick {tier.name}
              </Button>
            </div>
          </div>
        );
      })}
    </div>
  );
};
